import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const StatusWarning = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.11383 5.88634C7.04034 5.34539 7.46089 4.86385 8.00681 4.86385C8.54796 4.86385 8.96708 5.33743 8.90131 5.87457L8.54148 8.81287C8.50961 9.0731 8.28863 9.26868 8.02645 9.26868C7.76688 9.26868 7.54725 9.07686 7.5123 8.81965L7.11383 5.88634Z"
        fill="currentColor"
      />
      <path
        d="M8.02645 11.1291C8.38779 11.1291 8.6807 10.8361 8.6807 10.4748C8.6807 10.1135 8.38779 9.82057 8.02645 9.82057C7.66512 9.82057 7.37221 10.1135 7.37221 10.4748C7.37221 10.8361 7.66512 11.1291 8.02645 11.1291Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 12.75C10.6234 12.75 12.75 10.6234 12.75 8C12.75 5.37665 10.6234 3.25 8 3.25C5.37665 3.25 3.25 5.37665 3.25 8C3.25 10.6234 5.37665 12.75 8 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default StatusWarning;
